<template>
  <div class="common-error-handler">
    <div class="common-error-handler__error-wrap" v-if="showError">
      <h1 v-if="!!title" class="common-error-handler__title">
        <span>{{ title }}</span>
      </h1>
      <img class="common-error-handler__image" :src="image" />
      <p class="common-error-handler__desc">
        {{ desc }}
      </p>
    </div>
    <slot v-else></slot>
  </div>
</template>

<script>
// import HeaderNav from '@/components/common/HeaderNav';
import image from '@/assets/images/default/picture_empty_default.png';
import {cdnPrefix} from '@/util/common/cdn';

export default {
  name: 'CommonError',
  components: {
    // HeaderNav
  },
  props: {
    // error image url
    image: {
      type: String,
      default: cdnPrefix(image)
    },
    // show error page
    isError: {
      type: Boolean,
      default: false
    },
    // error title
    title: {
      type: String,
      default: ''
    },
    // error description
    desc: {
      type: String,
      default: ''
    }
  },
  data(){
    return {
      showError: this.isError
    };
  },
  watch: {
    isError(val){
      if (val !== this.showError){
        this.showError = val;
      }
    }
  },
  methods: {
    goBack(){
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/standard';
.common-error-handler {
  &__error-wrap {
    overflow: hidden;
    padding-top: sizeTrans(90);
    // padding-bottom: sizeTrans(40);
    @include pagePadding();
    color: $color_mb1_front;
  }
  &__title {
    text-align: left;
    margin-top: sizeTrans(5);
    margin-bottom: sizeTrans(48);
    @include font_h1_xl();
    white-space: break-spaces;
  }
  &__image {
    display: block;
    width: calcVw(320);
    max-width: sizeTrans(320);
    margin: 0 auto;
  }
  &__desc {
    margin-bottom: sizeTrans($space_60);
    color: $color_mb4_front;
    @include font_text_m($height_m);
    text-align: center;
  }
}
</style>